import { withFormik } from 'formik';
import { connect } from 'react-redux';
import { compose } from 'redux';
import styled from 'styled-components';
import { object, string } from 'yup';

import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalButtonGroup,
  ModalContent,
  ModalHeader,
  Button,
  FormLabel,
  ModalCloseButton,
} from '@frontend/legacy-components';

import Input, { InputDecorator } from 'components/lib2/TextInput';

import messages from 'constants/messages';

import { getActiveFile } from '../data/reducer';
import { applyRedactionsModal, applyRedactions } from './data/actions';
import {
  getRedactFileRequest,
  getIsApplyRedactionsModalOpen,
} from './data/reducer';

const Error = styled.div`
  color: #ed1d39;
`;

const Description = styled.div`
  margin-bottom: 1rem;
`;

const enhance = compose(
  connect(
    (state) => {
      const originalFilename = getActiveFile(state)?.filename ?? '';
      const containsPeriod = originalFilename.lastIndexOf('.') !== -1;
      const originalExtension = containsPeriod
        ? originalFilename.slice(originalFilename.lastIndexOf('.'))
        : '';
      const filename =
        (containsPeriod
          ? originalFilename.slice(0, originalFilename.lastIndexOf('.'))
          : originalFilename) + '-redacted';
      return {
        redactFileRequest: getRedactFileRequest(state),
        isOpen: getIsApplyRedactionsModalOpen(state),
        originalExtension,
        filename,
      };
    },
    {
      closeModal: applyRedactionsModal.close,
      applyRedactions: applyRedactions.request,
    },
  ),
  withFormik({
    enableReinitialize: true,
    handleSubmit: (values, { props }) => {
      const { applyRedactions, originalExtension } = props;
      const { name } = values;
      applyRedactions({ fileName: name + originalExtension });
    },
    mapPropsToValues: ({ filename }) => ({ name: filename }),
    validateOnBlur: true,
    validateOnChange: true,
    validationSchema: object().shape({
      name: string().required(messages.REQUIRED),
    }),
  }),
);

const ApplyRedactionsModal = ({
  closeModal,
  redactFileRequest,
  isOpen,
  originalExtension,
  handleChange,
  handleBlur,
  handleSubmit,
  errors,
  touched,
  values,
}) => {
  return (
    <Modal
      closable={true}
      destroyOnClose={true}
      footer={null}
      onClose={closeModal}
      isOpen={isOpen}
      returnFocusOnClose
      size="sm"
    >
      <ModalContent>
        <ModalHeader>
          Save Redactions to New PDF
          <ModalCloseButton />
        </ModalHeader>
        <form onSubmit={handleSubmit}>
          <ModalBody paddingY={3}>
            <Description>
              Redacted PDF will be saved as a new supporting file.
            </Description>
            <FormLabel>New File Name</FormLabel>
            <InputDecorator addonAfter={originalExtension}>
              <Input
                onChange={handleChange}
                onBlur={handleBlur}
                autoFocus
                value={values.name}
                name="name"
              />
            </InputDecorator>
            <Error>
              {errors.name && touched.name && (
                <div id="feedback">{errors.name}</div>
              )}
            </Error>
          </ModalBody>
          <ModalFooter>
            <ModalButtonGroup>
              <Button
                variant="primary"
                loading={redactFileRequest}
                type="submit"
              >
                Save
              </Button>
            </ModalButtonGroup>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default enhance(ApplyRedactionsModal);
